import { connect } from "react-redux";
import { Creators, getEditLane } from "../../reducer";
import LaneDrawer from "./LaneDrawer";

export default connect(
  state => ({
    editLane: getEditLane(state)
  }),
  dispatch => ({
    onCompleteEditLane: () => dispatch(Creators.completeEditLane()),
    onChangeLane: (location, range, laneNumber, updateLaneObject) =>
      dispatch(
        Creators.changeLane(location, range, laneNumber, updateLaneObject)
      ),
    onBackToQueue: (location, range, laneNumber) =>
      dispatch(Creators.backToQueue(location, range, laneNumber))
  })
)(LaneDrawer);



// WEBPACK FOOTER //
// ./src/staff/components/LaneDrawer/index.js